import { getData } from 'conversations-async-data/async-data/operators/getters';
// @ts-expect-error module not typed
import { provideThreadView } from 'conversations-thread-view/thread-view/decorators/provideThreadView';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { useConnectedAccounts } from 'conversations-thread-data/connected-accounts/public';
import { useFloatingEditorState } from '../hooks/useFloatingEditorState';
import { jsx as _jsx } from "react/jsx-runtime";
function useComponent({
  inboxId
}) {
  const {
    open: handleOpenFloatingEditor
  } = useFloatingEditorState();
  const {
    asyncConnectedAccounts
  } = useConnectedAccounts({
    inboxId,
    filterNonGlobalAccounts: true
  });
  const connectedAccounts = getData(asyncConnectedAccounts);
  const isVisible = connectedAccounts && connectedAccounts.size;
  return {
    handleOpenFloatingEditor,
    isVisible
  };
}
const _ComposeMessageButton = ({
  className,
  inboxId,
  label,
  use = 'tertiary'
}) => {
  const {
    handleOpenFloatingEditor,
    isVisible
  } = useComponent({
    inboxId
  });
  return isVisible ? /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": "compose-email-button",
    className: className,
    onClick: handleOpenFloatingEditor,
    size: "small",
    use: use,
    children: label || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.compose.compose-email-button.label"
    })
  }) : null;
};
_ComposeMessageButton.displayName = 'ComposeMessageButton';
export const ComposeMessageButton = provideThreadView(_ComposeMessageButton);
ComposeMessageButton._Internal = _ComposeMessageButton;